<template>
    <div class="w-full flex align-center justify-center my-custom-spinner">
        <div class="w-full h-full position-relative">
            <div class="loading">
                <div class="effects effect-1"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'custom-spinner'
}
</script>

<style lang="scss">
.my-custom-spinner {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    background: rgba(255, 255, 255, 1);
    .loading {
        position: absolute;
        left: calc(50% - 35px);
        top: 50%;
        width: 55px;
        height: 55px;
        border-radius: 50%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border: 3px solid transparent;
    }
    .loading .effect-1 {
        position: absolute;
        width: 80%;
        height: 80%;
        border: 3px solid transparent;
        border-left: 3px solid #2979FF;
        border-radius: 50%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        animation: rotate 1s ease infinite;
    }

    .loading .effects {
        transition: all .3s ease;
    }

    @keyframes rotate {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn);
        }
    }
    @keyframes rotateOpacity {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
            opacity: .1;
        }
        100% {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn);
            opacity: 1;
        }
    }
}
</style>